import apiClient from '../../../common/functions/api_axios_instance.function';
import {
  GET_ALL_RAN_DB_AUDIT_LOGS,
  RAN_DB_AUDIT_LOG_SITE,
} from '../../../common/constants/constants';

export const getFiberSiteAuditLogs = async (siteCode) => {
  try {
    if (siteCode) {
      // Using the same API structure as RAN DB but for fiber sites
      // TODO: Replace with actual fiber site audit endpoint when available
      // For now, using the same RAN DB endpoint as a placeholder
      const response = await apiClient.get(RAN_DB_AUDIT_LOG_SITE(siteCode), {});
      return response.data.response || [];
    }
  } catch (e) {
    return [];
  }
};

export const getAllFiberSiteAuditLogs = async () => {
  try {
    // Using the same API structure as RAN DB but for fiber sites
    // TODO: Replace with actual fiber site audit endpoint when available
    // For now, using the same RAN DB endpoint as a placeholder
    const response = await apiClient.get(GET_ALL_RAN_DB_AUDIT_LOGS, {
      params: {
        ftts: true,
      },
    });
    return response.data.response || [];
  } catch (e) {
    return [];
  }
};
